export default __webpack_public_path__ + "static/media/total-vaccinate-start-work-panel.ea88c343.svg";